import script from "./Standing.vue?vue&type=script&setup=true&lang=js"
export * from "./Standing.vue?vue&type=script&setup=true&lang=js"

import "./Standing.vue?vue&type=style&index=0&id=44c5938b&lang=scss"

const __exports__ = script;

export default __exports__